import { render, staticRenderFns } from "./login.vue?vue&type=template&id=8740c046&scoped=true&"
import script from "./login.vue.js?vue&type=script&lang=js&"
export * from "./login.vue.js?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=8740c046&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8740c046",
  null
  
)

export default component.exports